import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { NgRxState } from '@xbaht/common/modules/app-ngrx.module';

export const AuthGuardFn: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AuthGuard).canActivateChild(route, state);
};

export const AuthGuardChildFn: CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AuthGuard).canActivateChild(route, state);
};

@Injectable({ providedIn: 'root' })
class AuthGuard {
  constructor(private _router: Router, private _ngrxStore: Store<NgRxState>) {}

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return combineLatest([
      this._ngrxStore.select('Auth'),
      this._ngrxStore.select('Perm'),
    ]).pipe(
      map(([auth, perm]) => {
        if (auth.verified) {
          if (state.url.indexOf('/auth') > -1) {
            this._router.navigate([''], { replaceUrl: true });

            return false;
          } else {
            perm.permissions.forEach((value) =>
              value.permissions.forEach((perm) => {
                if (perm.url === state.url) {
                  if (!perm.accesses.includes('view')) {
                    this._router.navigate(['', 'misc', 'not-authorized'], {
                      replaceUrl: true,
                    });
                  }
                }
              })
            );

            return true;
          }
        } else {
          if (state.url.indexOf('/auth') < 0) {
            this._router.navigate(['', 'auth', 'sign-in'], {
              replaceUrl: true,
            });

            return false;
          } else {
            if (state.url === '/auth/2fa') {
              if (auth.email && !auth.verified) {
                return true;
              } else {
                this._router.navigate(['', 'auth', 'sign-in'], {
                  replaceUrl: true,
                });

                return false;
              }
            }

            return true;
          }
        }
      })
    );
  }
}
